import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminPedidosProducao: Routes = [
  {
    path: 'pedidos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PEDIDO',
      menuKey: 'PEDIDOS',
      breadcrumb: {
        label: 'Pedidos',
        icon: 'pi pi-fw pi-shopping-cart'
      },
      backend_path: '/pedidos'
    },
    loadChildren: () =>
      import('@app/modules/pedidos/pedidos.module').then(m => m.PedidosModule)
  },
  {
    path: 'relatorio/total_custos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'RELATORIO_PEDIDO',
      menuKey: 'RELATORIO',
      breadcrumb: {
        label: 'Relatório total de custos',
        icon: 'pi pi-fw pi-print'
      },
      backend_path: '/pedido_lotes'
    },
    loadChildren: () =>
      import('@app/modules/pedidos_lotes/pedido_lotes.module').then(m => m.PedidosLotesModule)
  },

  {
    path: 'observar',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'MONITORAMENTO_PEDIDO',
      menuKey: 'PEDIDOS',
      preload: false,
      backend_path: '/pedidos'
    },
    loadChildren: () =>
      import('@app/modules/monitoramento_pedido/monitoramento.module').then(
        m => m.MonitoramentoModule
      )
  },
  {
    path: 'relatorio',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'RELATORIO_PEDIDO',
      menuKey: 'RELATORIO',
      backend_path: '/domains'
    },
    loadChildren: () =>
      import('@app/modules/report/report.module').then(m => m.ReportModule)
  },

  {
    path: 'info_pedidos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'HISTORICO_PEDIDO',
      menuKey: 'PEDIDOS',
      breadcrumb: {
        label: 'Histórico do pedido',
        icon: 'pi pi-fw pi-history'
      }
    },
    loadChildren: () =>
      import('@app/modules/historico-pedidos/historico-pedidos.module').then(
        m => m.HistoricoPedidosModule
      )
  },
  {
    path: 'orcamentos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'ORCAMENTO',
      module: 'ORCAMENTO',
      breadcrumb: {
        label: 'Gerar orçamento',
        icon: 'mdi mdi-receipt-text-edit-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/orcamento/orcamento.module').then(
        m => m.OrcamentoModule
      )
  },
  {
    path: 'controle_orcamentos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'ORCAMENTO',
      module: 'CONTROLE_ORCAMENTO',
      breadcrumb: {
        label: 'Controle de orçamentos',
        icon: 'mdi mdi-receipt-text-clock-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/orcamento/controle_orcamento.module').then(
        m => m.ControleOrcamentoModule
      )
  }
];
